<template>
	<div>
		<el-tooltip content="密度"
			effect="dark"
			placement="top">
			<el-dropdown trigger="click"
				@command="tableSizeChange">
				<el-button circle
					size="mini">
					<i class="el-icon-full-screen"></i>
				</el-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="medium">正常</el-dropdown-item>
					<el-dropdown-item command="small">中等</el-dropdown-item>
					<el-dropdown-item command="mini">紧凑</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</el-tooltip>
		<el-tooltip content="刷新"
			effect="dark"
			placement="top">
			<el-button circle
				size="mini"
				@click="tableRefresh">
				<i class="el-icon-refresh"></i>
			</el-button>
		</el-tooltip>
		<el-tooltip content="列设置"
			effect="dark"
			placement="top">
			<el-popover placement="bottom"
				width="100"
				trigger="click">
				<el-checkbox-group v-model="checkedColumn"
					@change="columnShow">
					<el-checkbox v-for="(item, index) in option.column.columnList"
						:key="index"
						:label="item.prop">{{ item.label }}</el-checkbox>
				</el-checkbox-group>
				<span slot="reference">
					<el-button circle
						size="mini">
						<i class="el-icon-setting"></i>
					</el-button>
				</span>
			</el-popover>
		</el-tooltip>

	</div>
</template>

<script>
	export default {
		name: 'z-el-table-size',
		props: {
			option: {
				type: Object,
				required: true,
			},
		},
		data() {
			return {
				checkedColumn: [], // 默认选择中表格头
			}
		},
		created() {
			this.getCheckData();
		},
		methods: {
			getCheckData() {
				let arr = [];
				this.option.column.columnList.forEach(item => {
					if (!item.noShow) {
						arr.push(item.prop)
					}
				})
				this.checkedColumn = arr;
			},

			tableSizeChange(size) {
				this.option.table.size = size
				this.$emit("tableSizeChange", size)
			},
			tableRefresh() {
				this.$emit("tableRefresh")
			},
			columnShow() {
				let newArr = this.option.column.columnList.map(column => {
					if (!this.checkedColumn.includes(column.prop)) {
						column.noShow = true
					} else {
						column.noShow = false
					}
					return column
				})

				this.$set(this.option.column, 'columnList', newArr)
				this.$emit('columnShow', this.checkedColumn)
			},
		}
	}
</script>

<style>
</style>
